export const GET_ITEMS = "GET_ITEMS";
export const ITEMS_LOADING = "ITEMS_LOADING";
export const GET_RESULT = "GET_RESULT";
export const GET_HISTORY = "GET_HISTORY";
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const GET_ERRORS = "GET_ERRORS";
export const GAME_DONE = "GAME_DONE";
export const LOAD_COUPON = "LOAD_COUPON";
export const GET_KEY = "GET_KEY";
export const GAME_MAINTENANCE = "GAME_MAINTENANCE";
export const GAME_NOT_FOUND = "GAME_NOT_FOUND";
export const GAME_NOT_AVAILABLE = "GAME_NOT_AVAILABLE";
export const INSUFFICIENT_TICKET = "INSUFFICIENT_TICKET";
